import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Key, Plus } from "react-feather";
import { Helmet } from "react-helmet-async";
import { useBreadcrumbs } from "../../../context/BreadcrumbsContext";
import { ContentButton } from "../../../components/button/ContentButton";
import Textbox from "../../../components/textbox/Textbox";
import API from "../../../utils/api";
import { toast } from "../../../services/toast";

import "./NewApiKeychainPage.scss";
import { ApiKeychainSchema } from "../../../utils/types";
import { useAuth } from "../../../context/AuthContext";

export default function NewApiKeychainPage() {

  const { organization } = useAuth();
  const [alias, setAlias] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { updateBreadcrumbs } = useBreadcrumbs();

  const onSubmit = async () => {
    if (!alias) {
      toast.message({ type: 'error', message: 'Please enter an alias' });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await API.post(`v1/api_keychains`, { alias, organization: organization.name });
      const apiKeychain = response as ApiKeychainSchema;
      toast.message({ type: 'success', message: 'API keychain created successfully!' });
      navigate(`/dashboard/api-keychains/${apiKeychain.unique_id}`);
    } catch (error) {
      console.error(error);
      toast.message({ type: 'error', message: 'Failed to create API keychain' });
    }
    setIsSubmitting(false);
  };

  return (
    <div data-component="NewApiKeychainPage">
      <div className="content-container">
        <div className="form-container">
          <Textbox
            placeholder="Enter an alias for your API keychain"
            value={alias}
            autoFocus
            onChange={setAlias}
            onSubmit={onSubmit}
          />
          <div className="form-actions">
            <ContentButton
              color="blue"
              icon={Plus}
              disabled={alias.length === 0}
              onClick={onSubmit}
              loading={isSubmitting}
            >
              Create API keychain
            </ContentButton>
          </div>
        </div>
      </div>
    </div>
  );
} 